import { Box, Card, CardMedia, Grid, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery, useTheme } from "@mui/material";
import ImagenRecortada from "../Media/Imagen principal recortada.png"
import Imagen from "../Media/Imagen Principal.jpg"
import Decoracion from "../Media/Cuadros der.svg"
import FolderIcon from "../Media/Drive file move.svg"
import CelIcon from "../Media/Phone iphone.svg"
import MailIcon from "../Media/Mail outline.svg"
import { GetData } from "../services";
import { useEffect, useState } from "react";

const Home = () => {

  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isTablet = useMediaQuery(theme.breakpoints.only("sm"))
  const items = [
    "Cómo configurar mi cuenta de alumno",
    "Recuperar mi contraseña institucional",
    "Configurar mi llave digital en otro celular",
    "Re activar mi cuenta institucional",
  ];

  const [ListaLinks, SetListaLinks] = useState([])
  useEffect(() => {

    const LlenarCatalogo = async () => {

      try {
        const items = await GetData("Home/GetLinks");
        SetListaLinks(items);
      } catch (error) {
        console.error("Error al cargar los links:", error)
      }
    }
    LlenarCatalogo();
  }, [])

  return (
    <Grid container spacing={2} display={"flex"} paddingX={5} alignContent={"center"}>
      <Grid display={"flex"} size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: { xs: 400, sm: 700, lg: 500 }, // puedes ajustar esto
            margin: 'auto'

          }}
        >
          <Card sx={{ borderRadius: 4, overflow: 'hidden' }}>
            <CardMedia
              component="img"
              image={isMobileOrTablet ? Imagen : ImagenRecortada}
              alt="Personas"
              sx={{ width: '100%', height: { lg: '70vh' }, aspectRatio: { xs: 3 / 2, lg: 2 / 3 } }}
            />
          </Card>
          <Box
            component="img"
            src={Decoracion}
            alt="Decorativo"
            sx={{
              position: 'absolute',
              bottom: { xs: -40, sm: -50 }, // sale del borde
              left: { xs: -40, sm: -50 },
              width: { xs: 60, sm: 80, md: 100 },
              zIndex: -1,
            }}
          />

        </Box>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 7 }} sx={{ mt: isMobileOrTablet ? 5 : 0, marginLeft: isTablet ? 10 : 0 }} >
        <Typography variant="h5" color={theme.palette.primary.dark} fontWeight={800} alignSelf={"stretch"} >¿Necesitas ayuda?</Typography>
        <Typography variant={isMobileOrTablet ? "subtitle2" : "subtitle1"} color={theme.palette.text.primary} alignSelf={"stretch"} fontWeight={400}>Consulta alguno de nuestros manuales en busca de ayuda.</Typography>
        <List>
          {ListaLinks.map((item, index) => (
            <ListItem key={item.idEnlace} disableGutters sx={{ px: 0 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Box component="img" src={FolderIcon} sx={{ borderRadius: 1, padding: .4, backgroundColor: "#D5DCE3" }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    component="a"
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant={isMobileOrTablet ? "body2" : "body1"}
                    sx={{

                      textDecoration: 'underline',
                      textUnderlineOffset: '4px',
                      fontWeight: 700,
                      cursor: 'pointer',
                    }}
                    color={theme.palette.text.primary}
                  >
                    {item.tituloEnlace}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
        <Box component="br" />
        {!isMobileOrTablet ? (
          <Box component="br" />
        ) : null}


        <Typography variant={isMobileOrTablet ? "subtitle2" : "subtitle1"} color={theme.palette.text.primary} alignSelf={"stretch"} fontWeight={700}>También puedes contactarnos por el siguiente medio:</Typography>
        <List>
          <ListItem disableGutters sx={{ px: 0 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Box component="img" src={MailIcon} sx={{ borderRadius: 1, padding: .4 }} backgroundColor={theme.palette.info.main} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  variant={isMobileOrTablet ? "body2" : "body1"}
                  sx={{
                    textDecoration: 'underline',
                    textUnderlineOffset: '4px',
                    fontWeight: 700,
                  }}
                  color={theme.palette.info.main}
                >
                  soporteti@servicios.tecmilenio.mx
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Grid>

    </Grid>
  )
}
export default Home;